var $516e8cf2fe6c3a11$exports = {};
$516e8cf2fe6c3a11$exports = {
    "help": `S\xfag\xf3`,
    "info": `Inform\xe1ci\xf3`
};


export {$516e8cf2fe6c3a11$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
